import React from 'react'
import { Flex } from 'antd'
import { GetAccountResponse } from '@pushly/models/lib/structs'
import { FEAT_ACCOUNT_SECURITY_TAB } from '../../constants'
import { VERTICAL_WELL_GAP } from '../../theme/constants'
import { AccountDataForm } from '../../components/account-data-form/account-data-form'
import { UserList } from '../../components/user-list/user-list'
import { ApiTokensDataView } from '../../components/api-tokens/api-tokens-data-view'
import { ProviderList } from '../../components/account-security-settings/sso-idp-list'
import { AccountMfaSettings } from '../../components/account-mfa-settings/account-mfa-settings'
import { SessionTimeoutSettings } from '../../components/session-timeout-settings/session-timeout-settings'
import { ISettingsGroup, ISettingsPage } from './registry'

export interface IOrgSettingsContext {
    org: GetAccountResponse
}

/**
 * Grouped like the domain's rail: who and what the organization is, then Developers for the credentials
 * integrations use. The organization's Security page is single sign-on, MFA and session timeouts, which is
 * about people signing in, so it stays with the organization; the domain's Security is API tokens and secrets.
 */
export const ORG_SETTINGS_GROUPS: ISettingsGroup[] = [
    { key: 'organization', label: 'Organization' },
    { key: 'developers', label: 'Developers' },
]

/** Hash keys are the old tab keys, so existing links to `#users`, `#api-tokens` and `#security` keep working. */
export const ORG_SETTINGS_PAGES: ISettingsPage<IOrgSettingsContext>[] = [
    {
        key: 'settings',
        group: 'organization',
        label: 'Overview',
        visible: () => true,
        render: ({ org }) => <AccountDataForm key={`adf-${org.id}`} accountId={org.id} />,
    },
    {
        key: 'users',
        group: 'organization',
        label: 'Users',
        visible: () => true,
        render: ({ org }) => <UserList key={`aul-${org.id}`} options={{ accountId: org.id }} />,
    },
    {
        key: 'security',
        group: 'organization',
        label: 'Security',
        visible: ({ org }) => org.flags?.includes(FEAT_ACCOUNT_SECURITY_TAB) || false,
        render: ({ org }) => (
            <Flex vertical gap={VERTICAL_WELL_GAP}>
                <ProviderList key={`apl-${org.id}`} accountId={org.id} />
                <AccountMfaSettings key={`mfa-${org.id}`} />
                <SessionTimeoutSettings key={`sto-${org.id}`} />
            </Flex>
        ),
    },
    {
        key: 'api-tokens',
        group: 'developers',
        label: 'API Tokens',
        visible: () => true,
        render: ({ org }) => <ApiTokensDataView level="account" id={org.id} />,
    },
]
